export const ALL_STEPS = [
  { name: 'inattiva', value: 'idle' },
  { name: 'in attesa di ritiro', value: 'waiting_pickup' },
  { name: 'in transito', value: 'in_transit' },
  { name: 'consegnato', value: 'delivered' },
  { name: 'chiuso', value: 'closed' },
]
